import { db } from "~db/db";
import { roundAndAdjust } from "./searchHelpers";
import { deepCopy } from "~services/utils/deepCopy";

export const clientShareProccessData = ({ trilha, searchs, totalGraphItem }) => {
  let players = {};
  let labels = [];
  let dates = {};

  if(searchs && searchs.length > 0){
    let playerSearchs = {};
    let count = 0;
    let totalByDates = {};
    
    for(const e of searchs){
      let calc = e.volume;
      if(e.medida?.value && trilha == "TAC"){
        let toCalc = ['GRANEL'].includes(e.medida.unidade) ? 1 : 1000;
        calc = (e.volume * e.medida.value) / toCalc;
      }
      e.volumeCalc = calc;
  
      if(!dates[e.createdAt]){
        labels.push(e.dataLabel);
        const tempDate = {
          label: e.dataLabel,
          data: {},
        };
        dates[e.createdAt] = tempDate;
        totalByDates[e.createdAt] = 0;
      }
  
      const keyPlayer = `player-${e.playerId}`;
      if (players[keyPlayer] == undefined) {
        players[keyPlayer] = {
          id: e.playerId,
          label: e.player,
          backgroundColor: ++count,
          data: [],
          dates: [],
          volumeTotal: 0,
          volumePorMes: {},
          volumeAtivoPorMes: {}
        };
      }
  
      const keyPlayerDate = `player-${e.playerId}-${e.createdAt}`;
  
      playerSearchs[keyPlayerDate] ??= [];
      playerSearchs[keyPlayerDate].push(e);
  
      totalByDates[e.createdAt] += e.volumeCalc;
    }
  
    const sysDates = Object.keys(dates);
    const objPlayers = Object.values(players);
  
    for(const key of sysDates){
      let totalVolumeDia = totalByDates[key];
  
      for(const player of objPlayers){
        const id = player.id;
        const keyDatePlayer = `date-player-${id}`;
  
        //TRATATIVA UNIQUEDATA
        (playerSearchs[`player-${id}-${key}`] || []).forEach(el => {
          //TRATATIVA DATA
          dates[key].data[keyDatePlayer] = dates[key].data[keyDatePlayer] || {
            nome: el.player,
            volumeTotal: 0,
            volumeAtivo: 0,
            id: id,
            data: 0
          };
  
          dates[key].data[keyDatePlayer].volumeTotal += el.volume;
          dates[key].data[keyDatePlayer].volumeAtivo += el.volumeCalc;
          //FIM TRATATIVA DATA
        })
  
        //REALIZAÇÃO DOS CÁLCULOS
        const currentData = dates[key].data[keyDatePlayer];
  
        if (currentData) {
          const volumeAtivoPercentage = ((currentData.volumeAtivo / totalVolumeDia) * 100).toFixed(2);
          const percentage = isNaN(volumeAtivoPercentage) ? 0 : volumeAtivoPercentage;
  
          player.data.push(percentage);
          dates[key].data[keyDatePlayer].data = percentage;
          
          player.volumePorMes[key] = currentData.volumeTotal;
          player.volumeAtivoPorMes[key] = currentData.volumeAtivo;
          player.dates = sysDates;
        } else {
            player.data.push("");
        }
        //FIM REALIZAÇÃO DOS CÁLCULOS
      }
    }

    //AJUSTANDO OS VALORES PARA BATER 100%
    players = adjustValues({data: players, totalGraphItem});
  }

  return {
    labels,
    dates,
    players
  }
}

export const sellOutProccessData =  ({ searchs }) => {

  let dates = {};
  let prods = {};
  let playerProds = {};
  let labels = [];
  let count = 0;
  let produtos = [];
  for(const el of searchs){
    produtos.push(el.pesquisaProdutoId);

    if(!dates[el.createdAt]){
      labels.push(el.dataLabel);
      const tempDate = {
        label: el.dataLabel,
        data: {},
        uniqueData: {}
      };

      dates[el.createdAt] = tempDate;
    }

    const prodKey = `prod-player-${el.pesquisaPlayerId}-${el.pesquisaProdutoId}-${el.pesquisaCanalDistribuicaoId}-${el.pesquisaEmbalagemId}`;
    const prodDateKey = `prod-player-${el.pesquisaPlayerId}-${el.pesquisaProdutoId}-${el.pesquisaCanalDistribuicaoId}-${el.pesquisaEmbalagemId}-${el.createdAt}`;
    if (prods[prodKey] == undefined) {
      const color = ++count;
      prods[prodKey] = {
        key: prodKey,
        id: el.id,
        pesquisaProdutoId: el.pesquisaProdutoId,
        label: el.produto,
        pesquisaCanalDistribuicaoId: el.pesquisaCanalDistribuicaoId,
        pesquisaGrupoMaterialId: el.pesquisaGrupoMaterialId,
        pesquisaPlayerId: el.pesquisaPlayerId,
        pesquisaEmbalagemId: el.pesquisaEmbalagemId,
        grupoProduto: el.grupoProduto,
        player: el.player,
        embalagem: el.embalagem,
        backgroundColor: color,
        data: [],
        dates: [],
        borderWidth: 4,
        datalabels: {
          color: "#1C2B58",
        },
        pointRadius: 6,
      };

    }
    playerProds[prodDateKey] ??= [];
    playerProds[prodDateKey].push(el);
  }

  produtos = [...new Set(produtos)];
  const objProds = Object.values(prods);
  const sysDates = Object.keys(dates);

  for(const [key, valueDate] of Object.entries(dates)){
    for(const prod of objProds){
      if(prod.pesquisaProdutoId){

        const { pesquisaPlayerId, pesquisaProdutoId, pesquisaCanalDistribuicaoId, pesquisaEmbalagemId } = prod;

        const keyProdPlayer = `prod-player-${pesquisaPlayerId}-${pesquisaProdutoId}-${pesquisaCanalDistribuicaoId}-${pesquisaEmbalagemId}`;
        const keyProdDatePlayer = `prod-player-${pesquisaPlayerId}-${pesquisaProdutoId}-${pesquisaCanalDistribuicaoId}-${pesquisaEmbalagemId}-${key}`;

        (playerProds[keyProdDatePlayer] || []).forEach(el => {
          if(key == el.createdAt && !(el.deletadoEm ? new Date(el.deletadoEm) : null)){
            valueDate.data[keyProdPlayer] ??= {
              nome: el.produto,
              sellOutTotal: el.sellOut,
              id: el.pesquisaProdutoId,
              playerId: el.pesquisaPlayerId,
              idPesquisa: el.id
            };
          }
        })

        const cur = valueDate.data[keyProdPlayer];

        if (cur !== undefined) {
          prod.data.push(cur.sellOutTotal.toFixed(2));
          prod.dates = sysDates;
        } else {
          prod.data.push(null);
        }
      }
    }
  }

  return  {
    produtos,
    dates,
    prods,
    labels
  }
}

export const clientShareActivedCards = ({searchs, totalGraphItem, graficoClienteSharePlayers, trilha}) => {
  let graphData = searchs.reduce((acc, e) => acc.concat(e.values), []);
  let tempPlayers = [];
  
  if(graphData?.length){
    const { dates } = clientShareProccessData({searchs: graphData, totalGraphItem, trilha});
    
    if (dates && Object.keys(dates)?.length) {
      tempPlayers = deepCopy(graficoClienteSharePlayers);

      const [dateKey, dateFirst] = Object.entries(dates)[0] || [];
      const dateData = dateFirst?.data;
      
      if (dateData) {
        for (const player of Object.values(tempPlayers)) {
          const key = `date-player-${player.id}`;
          const currentData = dateData[key];
          
          if (currentData) {
            const index = player.dates?.indexOf(dateKey);
            if (index !== -1) {
              player.data[index] = currentData.data;
              player.volumePorMes[dateKey] = currentData.volumeAtivo;
              player.volumeAtivoPorMes[dateKey] = currentData.volumeAtivo;
            }
          }
        }

        tempPlayers = adjustValues({data: Object.values(tempPlayers), totalGraphItem});
      }
    }
  }  
  
  return tempPlayers;
}

export const sellOutActivedCards = ({searchs, graficoSellOutProds, totalGraphItem}) => {
  let graphData = searchs.reduce((acc, e) => acc.concat(e.values), []);
  let tempPlayers = {};
  
  if(graphData?.length){
    const { dates } = sellOutProccessData({searchs: graphData, totalGraphItem});
    
    if (dates && Object.keys(dates)?.length) {
      
      tempPlayers = deepCopy(graficoSellOutProds);
      
      const [dateKey, dateFirst] = Object.entries(dates)[0] || [];
      const dateData = dateFirst?.data;

      if (dateData) {
        for (const player of Object.values(tempPlayers)) {
          const key = `${player.key}`;
          const currentData = dateData[key];
          
          if (currentData) {
            const index = player.dates?.indexOf(dateKey);
            if (index !== -1) {
              player.data[index] = currentData.sellOutTotal.toFixed(2);
            }
          }
        }
      }
    }
  }

  return tempPlayers;
}

export const adjustValues = ({data, totalGraphItem}) => {
  let players = Object.values(data);
  let temp = [];
  for(let i = 0; i < totalGraphItem; i++){
    players?.forEach(e => {
      temp.push(e.data[i]);
    });
    const adjustedValues = roundAndAdjust(temp.map(e => e ? parseFloat(e) : 0));

    if(adjustedValues.length == temp.length && adjustedValues.every(e => !isNaN(e))){
      players = players.map((e,index) => {
        e.data[i] = adjustedValues[index] != 0 ? adjustedValues[index] : "";
        return e;
      });
    }

    temp = [];
  }

  return players;
}

export const searchsProccessData = async ({func = () => {}, objectData, totalGraphItem, filters, clienteId}) => {
  let agroupedDates = {};
  let keyValueAgrouped = [];

  await db.mapaDaMina.where('clienteId').equals(parseInt(clienteId)).and(func).each(el => {
    let cur = { ...el };
    const data = objectData["id-" + cur.id];
    if (data !== undefined && !data.clienteFechado) {
      const partesData = data.createdAt.split("/");
      cur.dataLabel = `${partesData[0]}/${partesData[1]}`;
      cur.createdAt = el.createdAt.split("T")[0];

      cur.grupoProduto = data.dadosGerais.grupoProduto?.nome ?? "";
      cur.player = data.dadosGerais.player?.nome ?? "";
      cur.playerId = data.dadosGerais.player?.id ?? 0;
      cur.produto = data.dadosGerais.produto?.nome ?? "";
      cur.volume = el.volume ? parseFloat(el.volume) : 0;
      cur.sellOut = el.sellOut ? parseFloat(el.sellOut) : 0;
      cur.medida = data.dadosGerais.embalagem ?? {};
      cur.embalagem = data.dadosGerais.embalagemCapacidade?.nome ?? "";

      const key = partesData.reverse().join('-');

      if(!agroupedDates[key]) agroupedDates[key] = [];

      agroupedDates[key].push(cur);
    }
  });

  Object.entries(agroupedDates).forEach(e => {
    keyValueAgrouped.push({
      key: e[0],
      values: e[1]
    })
  });

  const recentes = ["recentes",""].includes(filters.order);

  let temp = keyValueAgrouped.toSorted((a, b) => !recentes ? new Date(b.key) - new Date(a.key) : new Date(a.key) - new Date(b.key));
  temp = !recentes ? temp.slice(0, totalGraphItem) : temp.slice(-totalGraphItem);

  return temp;
}